export default __webpack_public_path__ + "static/media/Dodge.6333514b.png";